import { Card, Col, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicHtmlInputControls } from "../../../../Constant";
import { BASIC_HTML_INPUT_CONTROL } from "../../../../Data/FormControl/BaseInput";
import { BasicHtmlCardBody } from "./BasicHtmlCardBody";
import { BasicHtmlCardFooter } from "./BasicHtmlCardFooter";

const BasicHtmlInputControl = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={BasicHtmlInputControls} span={BASIC_HTML_INPUT_CONTROL} />
        <Form className="theme-form" onSubmit={(e)=>e.preventDefault()}>
          <BasicHtmlCardBody/>
          <BasicHtmlCardFooter/>
        </Form>
      </Card>
    </Col>
  );
};

export default BasicHtmlInputControl;
